import script from "./ArgonInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonInput.vue?vue&type=script&setup=true&lang=js"

import "./ArgonInput.vue?vue&type=style&index=0&id=6ea53c50&lang=css"

const __exports__ = script;

export default __exports__